<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Message') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">
          <div class="form-group">
            <label for="emailTo">{{ _('Recipient') }}</label>
  					<input class="form-control" type="email" id="emailTo" v-model="emailTo"> 
          </div>
          <div class="form-group">
            <label for="emailSubject">{{ _('Message subject') }}</label>
  					<input class="form-control" type="text" id="emailSubject" v-model="emailSubject"> 
          </div>
          <div class="form-group">
            <label for="emailBody">{{ _('Message') }}</label> 
            <textarea class="form-control" rows="10" wrap="virtual" id="emailBody" v-if="emailBody" v-model="emailBody"></textarea>
            <iframe width="100%" height="300px" border="0" frameborder="0" id="htmlBody" v-if="htmlBody" :src="htmlSrc"></iframe>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="sendEmail" :disabled="!canSend"><i class="fa fa-send fa-fw"></i> <template v-if="sendAnyway">{{ _('Send email anyway') }}</template><template v-else>{{ _('Send email') }}</template></button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import errors from '~/lib/errors'

export default {
  mixins: [errors],
  props: ['originalMessage', 'baseDomain', 'shopId', 'apiKey'],
  data () {
    return {
      message: {},
      sendAnyway: false
    }
  },
  computed: {
    shortLocale () {
      return this.locale.split('_')[0]
    },
    canSend () {
      return this.emailTo && this.emailSubject
    },
    emailTo: {
      get () {
        return this.message && this.message.data && this.message.data.recipients && this.message.data.recipients[0] ? this.message.data.recipients[0] : ''
      },
      set (newValue) {
        this.message.data.recipients[0] = newValue
      }
    },
    emailSubject: {
      get () {
        return this.message && this.message.data && this.message.data.subject ? this.message.data.subject : ''
      },
      set (newValue) {
        this.message.data.subject = newValue
      }
    },
    emailBody: {
      get () {
        return this.message && this.message.data && this.message.data.textbody ? this.message.data.textbody : ''
      },
      set (newValue) {
        this.message.data.textbody = newValue
      }
    },
    htmlBody () {
      return this.message && this.message.data && this.message.data.htmlbody ? this.message.data.htmlbody : ''
    },
    htmlSrc () {
      if (!this.message || !this.message.order_id || !this.message.identifier) {
        return 'about:blank'
      }
      return this.baseDomain + this.shopId + '/orders/' + this.message.order_id + '.json?rawmessage=' + this.message.identifier + '&apikey=' + this.apiKey
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    async sendEmail() {
      let response
      try {
        const data = {
          id: this.message.order_id,
          to: this.emailTo,
          subject: this.emailSubject,
          message: this.emailBody ? this.emailBody : ''
        }
        response = await axios.put(this.baseDomain + this.shopId + '/orders/' + this.message.order_id + '.json?message=' + this.message.identifier + (this.sendAnyway ? '&force=true' : '') +'&apikey=' + this.apiKey, data)
      } catch(e) {
        if (e && e.response && e.response.status === 400) {
          this.sendAnyway = true
        } else {
          this.sendAnyway = false
        }
        this.showError(e)
        return
      }
      this.showNotification(this._('Message sent!'))
      this.hideModal()
    }
  },
  created() {
    if (this.originalMessage) {
      this.message = Object.assign({}, this.originalMessage)
    }
  }
}
</script>